// extracted by css-extract-rspack-plugin
export default {"responsiveFrame":"product-detail-fragment__ResponsiveFrame_responsiveFrame__slyqP"};